/* global axios */
import ApiClient from './ApiClient';

// Propostas comerciais (aba Proposta do negócio). O builder manda SELEÇÕES —
// os preços oficiais vêm do backend (TemplateRegistry) e ficam congelados.
class ProposalsAPI extends ApiClient {
  constructor() {
    super('proposals', { accountScoped: true });
  }

  templates() {
    return axios.get(`${this.url}/templates`);
  }

  list(conversationId, mappingId) {
    return axios.get(this.url, {
      params: {
        conversation_id: conversationId,
        conversation_funnel_mapping_id: mappingId,
      },
    });
  }

  createProposal(payload) {
    return axios.post(this.url, payload);
  }

  markSent(id) {
    return axios.patch(`${this.url}/${id}`, { status: 'sent' });
  }

  deleteProposal(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  payments(id) {
    return axios.get(`${this.url}/${id}/payments`);
  }

  createPayment(id, payment) {
    return axios.post(`${this.url}/${id}/payments`, { payment });
  }

  refreshPayment(id, paymentId) {
    return axios.post(`${this.url}/${id}/payments/${paymentId}/refresh`);
  }
}

export default new ProposalsAPI();
